import global from "@/global";
import { createResourceService } from "@/query//createResourceService";
import { Notification } from "@/resources/types";

const { dataProvider, queryClient, client } = global;

export const notificationService = createResourceService<Notification>({
  resource: "notifications",
  client,
  dataProvider,
  queryClient,
});